<template>
  <div class="leading-normal px-12 mb-6">
    <icon name="attention_circle" :center="false" class="mx-auto mb-1 w-24 h-24 text-grey" />
    <h3 class="text-center mb-4">Order Cancelled</h3>
    <p class="text-center mb-6">Your print order has been cancelled.</p>
    <router-link to="/print-order-form" class="text-print-order-teal no-underline hover:underline">&lt; Start a new order</router-link>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
    }
  },
  props: ['order'],
  computed: {
    ...mapState(['selectedOffice'])
  },
  created () {
  },
  methods: {
  }
}
</script>
